

class FaqSection extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.querySelectorAll(".faq-item-title").forEach((button) => {
            button.addEventListener("click", this.toggleFaqItem.bind(this));
        });
    }


    toggleFaqItem(e) {
        const clickedContainer = e.currentTarget.parentNode;
        const clickedItem = clickedContainer.querySelector(".faq-item-text");
        const isCurrentlyOpen = clickedContainer.classList.contains("faq-item-active");

        // Close all other FAQ items
        this.querySelectorAll(".faq-item-container").forEach((container) => {
            if (container !== clickedContainer && container.classList.contains("faq-item-active")) {
                container.classList.remove("faq-item-active");
                container.querySelector(".faq-close").classList.remove("faq-display-none");
                container.querySelector(".faq-item-text").slideUp("250");
            }
        });

        // Toggle the clicked item
        e.currentTarget
            .querySelector(".faq-close")
            .classList.toggle("faq-display-none");

        clickedContainer.classList.toggle("faq-item-active");
        clickedItem.slideToggle("250");
    }

}

customElements.define('faq-section', FaqSection);